import React, { type FC, useEffect, useRef, useState } from 'react';

interface EditableTitleProps {
  initialText: string;
  onTitleChange?: (title: string) => void;
}

const EditableTitle: FC<EditableTitleProps> = ({
  initialText,
  onTitleChange,
}) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [title, setTitle] = useState<string>(initialText);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (isEditing && textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.select();
      // Auto-resize the textarea to fit content
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [isEditing]);

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTitle(e.target.value);
    // Auto-resize the textarea to fit content
    e.target.style.height = 'auto';
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  const finishEditing = (): void => {
    setIsEditing(false);
    if (onTitleChange) {
      onTitleChange(title);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>): void => {
    if (e.key === 'Enter' && !e.shiftKey) {
      finishEditing();
    }
  };

  const handleClick = (e: any) => {
    e.stopPropagation();
    setIsEditing(true);
  };

  return (
    <div className="rounded-lg w-full">
      {isEditing ? (
        <textarea
          ref={textareaRef}
          value={title}
          onChange={handleTextareaChange}
          onBlur={finishEditing}
          onKeyDown={handleKeyDown}
          className="outline-none rounded font-bold w-full resize-none overflow-hidden"
          rows={1}
        />
      ) : (
        <h1
          onDoubleClick={handleClick}
          className="cursor-pointer font-bold break-words whitespace-normal"
        >
          {title}
        </h1>
      )}
    </div>
  );
};

export default EditableTitle;
